module.exports = __webpack_public_path__ + "img/icon-search-white.38cb0b80.svg";